<template>
    <v-dialog
        v-model="dialog"
        :fullscreen="fullscreen"
        :max-width="maxWidth"
        :transition="transition"
        :overlay="!fullscreen"
        scrollable
    >
        <template v-slot:activator="{ on }">
            <v-list-tile href="#" ripple="ripple" rel="noopener" v-on="on">
                <v-list-tile-action>
                    <v-icon>lock</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>Alterar Senha</v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
        </template>
        <v-card>
            <v-toolbar card dark color="primary">
                <v-btn icon @click.native="toggleDialog" dark>
                    <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title>Alterar Senha</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark flat @click.native="save" :disabled="$v.$invalid || saving" :loading="saving">Salvar</v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
                <v-container grid-list-md>
                    <v-layout wrap>
                        <v-flex xs12 sm6>
                            <v-text-field
                                type="password"
                                label="Senha *"
                                v-model="objSenha.senha"
                                :error-messages="senhaErrors"
                                @input="$v.objSenha.senha.$touch()"
                                @blur="$v.objSenha.senha.$touch()"
                                required
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-text-field
                                type="password"
                                label="Confirme a Senha *"
                                v-model="objSenha.confirmaSenha"
                                :error-messages="confirmaSenhaErrors"
                                @input="$v.objSenha.confirmaSenha.$touch()"
                                @blur="$v.objSenha.confirmaSenha.$touch()"
                                required
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-container>
                <small>* Campos obrigatórios</small>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState         } from 'vuex';
import { validationMixin  } from 'vuelidate';
import { required, sameAs } from 'vuelidate/lib/validators';
import Util                 from '@/util';
import modalMixin           from '@/mixins/modalMixin';

export default {
    name        : 'SenhaModal',
    mixins      : [modalMixin, validationMixin],
    validations : {
        objSenha : {
            senha         : {
                required
            },
            confirmaSenha : {
                required,
                sameAsSenha: sameAs('senha')
            }
        }
    },
    methods     : {
        validatePwd() {
            if (this.objSenha.senha == "" && this.objSenha.confirmaSenha == "") {
                return {
                    valid : false,
                    msg   : 'A senha não foi informada!'
                }
            } else if (this.objSenha.senha !== this.objSenha.confirmaSenha) {
                return {
                    valid : false,
                    msg   : 'A senha não foi confirmada!'
                }
            } else {
                return {
                    valid : true
                }
            }
        },
        resetObjSenha() {
            this.objSenha = {
                senha         : '',
                confirmaSenha : ''
            };
        },
        save() {
            const validatedPwd = this.validatePwd();
            if (validatedPwd.valid) {
                this.saving = true;
                const route = `usuarios/${this.user.key}`;
                delete this.objSenha.confirmaSenha;
                this.$axios.patch(route, this.objSenha).then(response => {
                    this.resetObjSenha();
                    this.toggleDialog();
                    window.getApp.snackbar = {
                        show  : true,
                        color : 'green',
                        text  : 'Senha alterada com sucesso!'
                    };
                }).catch(error => {
                    const errorMsg = Util.getErrorMsg(error.response.data);
                    console.error(errorMsg.detailedMsg);
                    // this.toggleDialog();
                    window.getApp.snackbar = {
                        show      : true,
                        color     : 'red',
                        text      : errorMsg.msg
                    };
                }).finally(() => {
                    this.saving = false;
                });
            } else {
                window.getApp.snackbar = {
                    show  : true,
                    color : 'red',
                    text  : validatedPwd.msg
                };
            }
        }
    },
    computed    : {
        ...mapState(['user']),
        senhaErrors () {
            const errors = []
            if (!this.$v.objSenha.senha.$dirty) {
                return errors;
            }
            !this.$v.objSenha.senha.required && errors.push('O campo Senha é obrigatório.');
            !this.$v.objSenha.confirmaSenha.sameAsSenha && errors.push('A Senha não foi confirmada.');
            return errors;
        },
        confirmaSenhaErrors () {
            const errors = []
            if (!this.$v.objSenha.confirmaSenha.$dirty) {
                return errors;
            }
            !this.$v.objSenha.confirmaSenha.required && errors.push('O campo Confirme a Senha é obrigatório.');
            !this.$v.objSenha.confirmaSenha.sameAsSenha && errors.push('A Senha não foi confirmada.');
            return errors;
        },
    },
    watch       : {
        dialog(novo, antigo) {
            if (novo) {
                this.resetObjSenha();
            }
        }
    },
    data() {
        return {
            objSenha : {}
        };
    }
};
</script>
